import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Making innovation happen
                                            </div>
                                            <p>Now that you have used the questioning techniques to
                                                encourage innovation, here are some
                                                further tips to help you make innovation happen. </p>
                                            <div className="border_subtitle"> Give yourself time for thought
                                                leadership
                                            </div>
                                            <p>The single, clearest measure of our conscious or unconscious
                                                work priorities is how we use our
                                                time. Think of an average day, week or month and identify
                                                where your time goes. It will be unsurprising if you find
                                                that the great majority of your time goes on operational
                                                'task' matters and that relatively little goes on thought
                                                leadership and innovation. No matter which technique for
                                                brainstorming, reframing issues, asking yourself key
                                                questions or creating a shift in your approach that you
                                                adopt, it will not thrive if you don't make time. This means
                                                recognising that innovation has
                                                a sufficiently high priority for you to devote significant
                                                time to it. </p>
                                            <div className="border_subtitle">Know yourself, know your team
                                            </div>
                                            <p>Individuals vary widely in terms of strengths and risks
                                                relating to their capacity to innovate. You need to
                                                recognise these, both in yourself and in your
                                                team/colleagues. Your signature strengths - and those of
                                                your team - in relation to innovation may already be
                                                apparent to you. If you think
                                                this needs more consideration then look at some of the other
                                                diagnostics in the iLEAD™ stable; for example, Big 5
                                                Personality Theory in 'How to identify personal learning
                                                styles' (in the People Leadership book). </p>
                                            <div className="border_subtitle">Practise innovation</div>
                                            <p>Play 'just suppose' - imagine a situation where a standard
                                                assumption no longer holds true. For example, suppose that
                                                Britain had the same climate as Egypt - what would this
                                                mean; what possibilities would arise? Suppose that a law was
                                                passed cutting the working week to 20 hours • how would you
                                                do business? Suppose that your strongest product didn't
                                                exist - how would you
                                                fill the gap? Take any aspect of your business or working
                                                life that you take for granted and then throw away the
                                                assumptions. </p>
                                            <div className="border_subtitle">Reinvent the wheel</div>
                                            <p>Take one of your tried and tested products or processes and
                                                work out what it would take to replace it with something
                                                better - you can bet your competition is doing just
                                                this! </p>
                                            <div className="border_subtitle">Check your personal, team and
                                                business 'innovation climate'
                                            </div>
                                            <span
                                                style={{color: '#000'}}>Ask yourself the following questions: </span><br/>
                                            <ul className="greenbullet-list1 septor">
                                                <li><span className="green">A.</span> What supports or
                                                    stiﬂes innovation around here?
                                                </li>
                                                <li><span className="green">B.</span> When do I have and
                                                    share good ideas - do we have forums where this happens?
                                                </li>
                                                <li><span className="green">C.</span> When do I feel
                                                    insecure about trying something new; how can I create
                                                    the conditions in which
                                                    my ingenuity thrives?
                                                </li>
                                                <li><span className="green">D.</span> How often does the
                                                    team get together to speculate rather than to
                                                    coordinate?
                                                </li>
                                            </ul>


                                            <p className="para-first-pad">Above all encourage and develop
                                                skilled managers and leaders who create the conditions in
                                                which people feel free to innovate and, as important, who
                                                recognise and remove the barriers to divergent thinking. As
                                                one senior business leader told me: 'We spend a fortune
                                                recruiting the brightest, most creative and most
                                                enterprising people and then spend the next five years
                                                accidentally beating it out of them, so all their ﬂair goes
                                                into their hobbies, their homes, their
                                                ﬂower beds!' </p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}